/**
 * readAsMarked
 * @param element
 */
window.readAsMarked = function(element) {
  $.ajax({
    url: BASE_PATH + 'ajax/helper/additional/ajax.setNotificationRead',
    type: 'post',
    data: {
      messageKey: $(element).closest('li').data('key'),
      checked: $(element).is(':checked'),
    },
    success: function() {
      ListNotifications.updater();
      ListNotificationShort.updater();
    },
  });
};

/**
 * doOnclick
 * @param href
 */
window.doOnclick = function(href) {
  if (!event.target.classList.contains('morelink')) {
    window.location = href;
  }
};

/**
 * tabbing
 * @param tab
 * @param sec
 * @param savetab
 * @returns {boolean}
 */
window.tabbing = function (tab, sec, savetab) {
  // Switch all Tabs
  $(tab).siblings().removeClass('active');
  $(tab).addClass('active');
  $(tab).siblings().each(function () {
    var link = $(this).attr('href');
    $(link).removeClass('active');
  });

  $($(tab).attr('href')).addClass('active');

  if (typeof savetab !== 'undefined') {
    $.ajax({
      url: BASE_PATH + 'ajax/helper/additional/ajax.tabHandling',
      type: 'post',
      data: {
        lastTab: $(tab).attr('href').replace('#', ''),
        section: sec
      }
    });
  }
  return false;
}